/**
 * Key bí mật dùng để mã hóa thông tin user cho hệ thống live chat
 */
export const CHAT_SECRET_KEY = "your-super-secret-key-here-change-this-in-production";

export const CHAT_BASE_URL = "https://a1234.119119.eu.cc/chat-b64";

export interface IChatUser {
  username?: string;
  id?: string | number;
  [key: string]: any;
}

/**
 * Mã hóa chuỗi bằng thuật toán XOR đơn giản kết hợp base64
 * @param text Chuỗi cần mã hóa
 * @param key Key bảo mật (mặc định lấy CHAT_SECRET_KEY)
 */
export const simpleEncrypt = (
  text: string,
  key: string = CHAT_SECRET_KEY
): string => {
  let result = "";
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    result += String.fromCharCode(charCode);
  }
  return btoa(result);
};

/**
 * Tạo URL chat mã hóa dựa trên thông tin người dùng
 * @param user Đối tượng user chứa username và id
 * @param baseUrl URL gốc của dịch vụ chat (mặc định: https://a1234.119119.eu.cc/chat-b64)
 * @returns Đường dẫn chat hoàn chỉnh
 * 
 * Ví dụ:
 * getChatUrl(user) 
 * // -> "https://a1234.119119.eu.cc/chat-b64/..."
 */
export const getChatUrl = (
  user?: IChatUser | null,
  baseUrl: string = CHAT_BASE_URL
): string => {
  const userId = user?.id ?? (user as any)?._id;
  const userIdentifier = user?.username
    ? userId
      ? `${user.username}(${userId})`
      : user.username
    : "guest";

  const rawPath = `/user/vinhomes365/${userIdentifier}`;
  const encryptedPath = simpleEncrypt(rawPath);

  return `${baseUrl}/${encryptedPath}`;
};

/**
 * Tiện ích mở cửa sổ chat mới trong trình duyệt
 * @param user Đối tượng user
 * @param target Target mở link (mặc định: "_blank")
 */
export const openChatWindow = (
  user?: IChatUser | null,
  target: string = "_blank"
): void => {
  const url = getChatUrl(user);
  if (typeof window !== "undefined") {
    window.open(url, target);
  }
};
